module.exports = __webpack_public_path__ + "assets/img/binom-d.a02da692.png";